"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UseCaseFactory = void 0;

var ActivityLog_1 = require("./ActivityLog");

var Allotment_1 = require("./Allotment");

var Answer_1 = require("./Answer");

var AppVersion_1 = require("./AppVersion");

var BugReport_1 = require("./BugReport");

var Campaign_1 = require("./Campaign");

var Canvas_1 = require("./Canvas");

var Country_1 = require("./Country");

var DomainMask_1 = require("./DomainMask");

var EFx_1 = require("./EFx");

var EmailDesign_1 = require("./EmailDesign");

var EmailDesignType_1 = require("./EmailDesignType");

var EmailMessage_1 = require("./EmailMessage");

var EmailNotification_1 = require("./EmailNotification");

var EmailSample_1 = require("./EmailSample");

var EmailTemplate_1 = require("./EmailTemplate");

var Event_1 = require("./Event");

var EventTheme_1 = require("./EventTheme");

var Exhibitor_1 = require("./Exhibitor");

var Feature_1 = require("./Feature");

var FeatureToggle_1 = require("./FeatureToggle");

var Group_1 = require("./Group");

var HealthPass_1 = require("./HealthPass");

var Import_1 = require("./Import");

var Integration_1 = require("./Integration");

var IntegrationFieldMapping_1 = require("./IntegrationFieldMapping");

var IntegrationStatusMapping_1 = require("./IntegrationStatusMapping");

var Invitation_1 = require("./Invitation");

var Lead_1 = require("./Lead");

var Link_1 = require("./Link");

var Logi_1 = require("./Logi");

var Mobile_1 = require("./Mobile");

var OAuth_1 = require("./OAuth");

var OAuth2_1 = require("./OAuth2");

var Payment_1 = require("./Payment");

var PaymentGateway_1 = require("./PaymentGateway");

var Pool_1 = require("./Pool");

var PoolAllotment_1 = require("./PoolAllotment");

var PoolContact_1 = require("./PoolContact");

var PoolContract_1 = require("./PoolContract");

var PoolFeature_1 = require("./PoolFeature");

var PoolFile_1 = require("./PoolFile");

var PoolImage_1 = require("./PoolImage");

var PoolPaymentGateway_1 = require("./PoolPaymentGateway");

var PoolWorld_1 = require("./PoolWorld");

var Profile_1 = require("./Profile");

var Promotion_1 = require("./Promotion");

var Question_1 = require("./Question");

var Queue_1 = require("./Queue");

var Refund_1 = require("./Refund");

var Region_1 = require("./Region");

var Report_1 = require("./Report");

var Salesforce_1 = require("./Salesforce");

var SalesforceEventSetting_1 = require("./SalesforceEventSetting");

var SalesforcePoolSetting_1 = require("./SalesforcePoolSetting");

var Salutation_1 = require("./Salutation");

var SitePage_1 = require("./SitePage");

var Stack_1 = require("./Stack");

var TicketBlock_1 = require("./TicketBlock");

var TicketType_1 = require("./TicketType");

var Track_1 = require("./Track");

var Transaction_1 = require("./Transaction");

var Transfer_1 = require("./Transfer");

var User_1 = require("./User");

var UserAddress_1 = require("./UserAddress");

var UserAttribute_1 = require("./UserAttribute");

var UserIdentifier_1 = require("./UserIdentifier");

var UserName_1 = require("./UserName");

var UserUnsubscribe_1 = require("./UserUnsubscribe");

var Venue_1 = require("./Venue");

var Virbela_1 = require("./Virbela");

var VirbelaWorld_1 = require("./VirbelaWorld");

var WebConference_1 = require("./WebConference");

var Withdrawal_1 = require("./Withdrawal");

var UseCaseFactory =
/** @class */
function () {
  function UseCaseFactory(restClient) {
    this.restClient = restClient;
  }

  UseCaseFactory.prototype.ActivityLog = function () {
    return new ActivityLog_1.ActivityLog(this.restClient);
  };

  UseCaseFactory.prototype.Allotment = function () {
    return new Allotment_1.Allotment(this.restClient);
  };

  UseCaseFactory.prototype.Answer = function () {
    return new Answer_1.Answer(this.restClient);
  };

  UseCaseFactory.prototype.AppVersion = function () {
    return new AppVersion_1.AppVersion(this.restClient);
  };

  UseCaseFactory.prototype.BugReport = function () {
    return new BugReport_1.BugReport(this.restClient);
  };

  UseCaseFactory.prototype.Campaign = function () {
    return new Campaign_1.Campaign(this.restClient);
  };

  UseCaseFactory.prototype.Canvas = function () {
    return new Canvas_1.Canvas(this.restClient);
  };

  UseCaseFactory.prototype.Country = function () {
    return new Country_1.Country(this.restClient);
  };

  UseCaseFactory.prototype.DomainMask = function () {
    return new DomainMask_1.DomainMask(this.restClient);
  };

  UseCaseFactory.prototype.EFx = function () {
    return new EFx_1.EFx(this.restClient);
  };

  UseCaseFactory.prototype.EmailDesign = function () {
    return new EmailDesign_1.EmailDesign(this.restClient);
  };

  UseCaseFactory.prototype.EmailDesignType = function () {
    return new EmailDesignType_1.EmailDesignType(this.restClient);
  };

  UseCaseFactory.prototype.EmailMessage = function () {
    return new EmailMessage_1.EmailMessage(this.restClient);
  };

  UseCaseFactory.prototype.EmailNotification = function () {
    return new EmailNotification_1.EmailNotification(this.restClient);
  };

  UseCaseFactory.prototype.EmailSample = function () {
    return new EmailSample_1.EmailSample(this.restClient);
  };

  UseCaseFactory.prototype.EmailTemplate = function () {
    return new EmailTemplate_1.EmailTemplate(this.restClient);
  };

  UseCaseFactory.prototype.Event = function () {
    return new Event_1.Event(this.restClient);
  };

  UseCaseFactory.prototype.EventTheme = function () {
    return new EventTheme_1.EventTheme(this.restClient);
  };

  UseCaseFactory.prototype.Exhibitor = function () {
    return new Exhibitor_1.Exhibitor(this.restClient);
  };

  UseCaseFactory.prototype.Feature = function () {
    return new Feature_1.Feature(this.restClient);
  };

  UseCaseFactory.prototype.FeatureToggle = function () {
    return new FeatureToggle_1.FeatureToggle(this.restClient);
  };

  UseCaseFactory.prototype.Group = function () {
    return new Group_1.Group(this.restClient);
  };

  UseCaseFactory.prototype.HealthPass = function () {
    return new HealthPass_1.HealthPass(this.restClient);
  };

  UseCaseFactory.prototype.Import = function () {
    return new Import_1.Import(this.restClient);
  };

  UseCaseFactory.prototype.Integration = function () {
    return new Integration_1.Integration(this.restClient);
  };

  UseCaseFactory.prototype.IntegrationFieldMapping = function () {
    return new IntegrationFieldMapping_1.IntegrationFieldMapping(this.restClient);
  };

  UseCaseFactory.prototype.IntegrationStatusMapping = function () {
    return new IntegrationStatusMapping_1.IntegrationStatusMapping(this.restClient);
  };

  UseCaseFactory.prototype.Invitation = function () {
    return new Invitation_1.Invitation(this.restClient);
  };

  UseCaseFactory.prototype.Lead = function () {
    return new Lead_1.Lead(this.restClient);
  };

  UseCaseFactory.prototype.Link = function () {
    return new Link_1.Link(this.restClient);
  };

  UseCaseFactory.prototype.Logi = function () {
    return new Logi_1.Logi(this.restClient);
  };

  UseCaseFactory.prototype.Mobile = function () {
    return new Mobile_1.Mobile(this.restClient);
  };

  UseCaseFactory.prototype.OAuth = function () {
    return new OAuth_1.OAuth(this.restClient);
  };

  UseCaseFactory.prototype.OAuth2 = function () {
    return new OAuth2_1.OAuth2(this.restClient);
  };

  UseCaseFactory.prototype.Payment = function () {
    return new Payment_1.Payment(this.restClient);
  };

  UseCaseFactory.prototype.PaymentGateway = function () {
    return new PaymentGateway_1.PaymentGateway(this.restClient);
  };

  UseCaseFactory.prototype.Pool = function () {
    return new Pool_1.Pool(this.restClient);
  };

  UseCaseFactory.prototype.PoolAllotment = function () {
    return new PoolAllotment_1.PoolAllotment(this.restClient);
  };

  UseCaseFactory.prototype.PoolContact = function () {
    return new PoolContact_1.PoolContact(this.restClient);
  };

  UseCaseFactory.prototype.PoolContract = function () {
    return new PoolContract_1.PoolContract(this.restClient);
  };

  UseCaseFactory.prototype.PoolFeature = function () {
    return new PoolFeature_1.PoolFeature(this.restClient);
  };

  UseCaseFactory.prototype.PoolFile = function () {
    return new PoolFile_1.PoolFile(this.restClient);
  };

  UseCaseFactory.prototype.PoolImage = function () {
    return new PoolImage_1.PoolImage(this.restClient);
  };

  UseCaseFactory.prototype.PoolPaymentGateway = function () {
    return new PoolPaymentGateway_1.PoolPaymentGateway(this.restClient);
  };

  UseCaseFactory.prototype.PoolWorld = function () {
    return new PoolWorld_1.PoolWorld(this.restClient);
  };

  UseCaseFactory.prototype.Profile = function () {
    return new Profile_1.Profile(this.restClient);
  };

  UseCaseFactory.prototype.Promotion = function () {
    return new Promotion_1.Promotion(this.restClient);
  };

  UseCaseFactory.prototype.Question = function () {
    return new Question_1.Question(this.restClient);
  };

  UseCaseFactory.prototype.Queue = function () {
    return new Queue_1.Queue(this.restClient);
  };

  UseCaseFactory.prototype.Refund = function () {
    return new Refund_1.Refund(this.restClient);
  };

  UseCaseFactory.prototype.Region = function () {
    return new Region_1.Region(this.restClient);
  };

  UseCaseFactory.prototype.Report = function () {
    return new Report_1.Report(this.restClient);
  };

  UseCaseFactory.prototype.Salesforce = function () {
    return new Salesforce_1.Salesforce(this.restClient);
  };

  UseCaseFactory.prototype.SalesforceEventSetting = function () {
    return new SalesforceEventSetting_1.SalesforceEventSetting(this.restClient);
  };

  UseCaseFactory.prototype.SalesforcePoolSetting = function () {
    return new SalesforcePoolSetting_1.SalesforcePoolSetting(this.restClient);
  };

  UseCaseFactory.prototype.Salutation = function () {
    return new Salutation_1.Salutation(this.restClient);
  };

  UseCaseFactory.prototype.SitePage = function () {
    return new SitePage_1.SitePage(this.restClient);
  };

  UseCaseFactory.prototype.Stack = function () {
    return new Stack_1.Stack(this.restClient);
  };

  UseCaseFactory.prototype.TicketBlock = function () {
    return new TicketBlock_1.TicketBlock(this.restClient);
  };

  UseCaseFactory.prototype.TicketType = function () {
    return new TicketType_1.TicketType(this.restClient);
  };

  UseCaseFactory.prototype.Track = function () {
    return new Track_1.Track(this.restClient);
  };

  UseCaseFactory.prototype.Transaction = function () {
    return new Transaction_1.Transaction(this.restClient);
  };

  UseCaseFactory.prototype.Transfer = function () {
    return new Transfer_1.Transfer(this.restClient);
  };

  UseCaseFactory.prototype.User = function () {
    return new User_1.User(this.restClient);
  };

  UseCaseFactory.prototype.UserAddress = function () {
    return new UserAddress_1.UserAddress(this.restClient);
  };

  UseCaseFactory.prototype.UserAttribute = function () {
    return new UserAttribute_1.UserAttribute(this.restClient);
  };

  UseCaseFactory.prototype.UserIdentifier = function () {
    return new UserIdentifier_1.UserIdentifier(this.restClient);
  };

  UseCaseFactory.prototype.UserName = function () {
    return new UserName_1.UserName(this.restClient);
  };

  UseCaseFactory.prototype.UserUnsubscribe = function () {
    return new UserUnsubscribe_1.UserUnsubscribe(this.restClient);
  };

  UseCaseFactory.prototype.Venue = function () {
    return new Venue_1.Venue(this.restClient);
  };

  UseCaseFactory.prototype.Virbela = function () {
    return new Virbela_1.Virbela(this.restClient);
  };

  UseCaseFactory.prototype.VirbelaWorld = function () {
    return new VirbelaWorld_1.VirbelaWorld(this.restClient);
  };

  UseCaseFactory.prototype.WebConference = function () {
    return new WebConference_1.WebConference(this.restClient);
  };

  UseCaseFactory.prototype.Withdrawal = function () {
    return new Withdrawal_1.Withdrawal(this.restClient);
  };

  return UseCaseFactory;
}();

exports.UseCaseFactory = UseCaseFactory;